import React, { Fragment, useState } from 'react';
import Services from '../../api/service'
import { useParams } from 'react-router-dom'
import ModalVideo from 'react-modal-video'
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import Bg from '../../images/bg/page_bg01.jpg'
import icon from '../../images/icon/ser-01.svg'
import srImg from '../../images/shape/brd_shape.png'
import srImg2 from '../../images/hero/22.png'
import vImg from '../../images/video/image.png'
import vImg2 from '../../images/video/polygon02.png'
import sImg1 from '../../images/icon/sd-icon01.svg'
import sImg2 from '../../images/icon/sd-icon02.svg'
import sImg3 from '../../images/icon/sd-icon03.svg'
import sImg4 from '../../images/icon/sd-icon04.svg'
import shape from '../../images/shape/sd-shape.png'
import sicon from '../../images/icon/check-icon.svg'


const ServiceSinglePage = (props) => {

    const { slug } = useParams()

    const ServiceDetails = Services.find(item => item.slug === slug)

    const [isOpen, setOpen] = useState(false)

    // Dynamic Implementation Process based on service
    const getImplementationProcess = () => {
        if (slug.includes('Ecommerce') || slug.includes('Shopify') || slug.includes('Magento')) {
            return {
                title: "E-Commerce Integration Process",
                description: "Uniflame’s proven way to connect Odoo with your online store—keeping data in sync, orders flowing, and operations stable.",
                steps: [
                    { title: "Store analysis & mapping", description: "We review your catalog, pricing, and customers to design the ideal sync model.", number: "01" },
                    { title: "API configuration & setup", description: "We configure webhooks, APIs, and field mapping between Odoo and your store.", number: "02" },
                    { title: "Data sync & testing", description: "We import products, test order flows, and validate inventory synchronization.", number: "03" },
                    { title: "Go-live & monitoring", description: "We launch the integration, monitor real usage, and support ongoing tuning.", number: "04" }
                ]
            }
        } else if (slug.includes('Mobile-App')) {
            return {
                title: "Mobile app development process",
                description: "Agile delivery from idea to launch—Uniflame builds mobile apps tightly connected to Odoo and your e-commerce stack.",
                steps: [
                    { title: "Requirements & UX design", description: "We define user flows, features, and design clean, intuitive mobile screens.", number: "01" },
                    { title: "API & backend integration", description: "We connect the app to Odoo APIs for secure, real-time business data.", number: "02" },
                    { title: "Development & testing", description: "We build, test on real devices, and ensure performance and reliability.", number: "03" },
                    { title: "Deployment & updates", description: "We publish to stores and support future updates and feature releases.", number: "04" }
                ]
            }
        } else if (slug.includes('Manufacturing') || slug.includes('Inventory') || slug.includes('POS')) {
            return {
                title: "Module implementation process",
                description: "Uniflame’s structured approach to deploying Odoo modules—from setup to user adoption and continuous improvement.",
                steps: [
                    { title: "Business process mapping", description: "We capture your current flows, bottlenecks, and ideal Odoo design.", number: "01" },
                    { title: "System configuration", description: "We configure products, routes, work centers, rules, and permissions.", number: "02" },
                    { title: "User training & testing", description: "Key users are trained, pilots run, and settings refined from feedback.", number: "03" },
                    { title: "Go-live & optimization", description: "We go live, track KPIs, and optimize throughput, stock and control.", number: "04" }
                ]
            }
        } else if (slug.includes('Data-Migration') || slug.includes('Integration-API')) {
            return {
                title: "Data migration & integration process",
                description: "Safe, predictable migration and integration by Uniflame—focused on accuracy, auditability, and minimal downtime.",
                steps: [
                    { title: "Data assessment & planning", description: "We analyze source systems, define mapping rules, and plan the cutover.", number: "01" },
                    { title: "Data cleansing & transform", description: "We clean, validate, and transform data to match Odoo structures.", number: "02" },
                    { title: "Test migration & validation", description: "We run trial imports, compare results, and resolve inconsistencies.", number: "03" },
                    { title: "Final migration & support", description: "We execute the final move and support your team post-go-live.", number: "04" }
                ]
            }
        } else {
            return {
                title: "Implementation process",
                description: "Uniflame follows a clear Odoo delivery model—discovery, configuration, integrations, and go-live—with measurable outcomes at each stage.",
                steps: [
                    { title: "Discovery & blueprint", description: "We map requirements, processes, and KPIs into an Odoo blueprint.", number: "01" },
                    { title: "Configuration & data", description: "We configure modules, migrate clean data, and secure access rights.", number: "02" },
                    { title: "Integrations & automation", description: "We connect Magento/Shopify and add custom flows and automations.", number: "03" },
                    { title: "UAT, go-live & handover", description: "Users test, we go live, and hand over with training and support.", number: "04" }
                ]
            }
        }
    }

    // Dynamic Service Outcomes based on service
    const getServiceOutcomes = () => {
        if (slug.includes('Ecommerce') || slug.includes('Shopify') || slug.includes('Magento')) {
            return [
                "Real-time inventory sync between store and Odoo",
                "Automated order processing and fulfillment workflows",
                "Unified customer data across web, POS and ERP",
                "Accurate financial postings and e-commerce accounting",
                "Less manual re-entry and fewer operational errors",
                "Architecture ready for multi-store and multi-channel"
            ]
        } else if (slug.includes('Mobile-App')) {
            return [
                "Odoo data available anywhere on mobile devices",
                "Offline support for field teams, sales and service",
                "Instant synchronization with the central ERP system",
                "Higher productivity for on-the-go business users",
                "Faster CRM, ticket and activity updates for clients",
                "Modern native experience with alerts and push notifications"
            ]
        } else if (slug.includes('Manufacturing')) {
            return [
                "Live visibility into production status and bottlenecks",
                "Optimized work orders, BoMs and routing in Odoo",
                "Lower manufacturing costs and reduced material waste",
                "Improved on-time delivery and lead time control",
                "Better planning of capacity, machines and manpower",
                "Quality checks, traceability and compliance tracking"
            ]
        } else if (slug.includes('Inventory')) {
            return [
                "Real-time stock visibility across warehouses",
                "Smart replenishment with rules and lead times",
                "Barcode-driven picking, packing and moves",
                "Reduced stockouts and excess inventory levels",
                "Efficient multi-warehouse and location handling",
                "Improved inventory turnover and cost accuracy"
            ]
        } else if (slug.includes('POS')) {
            return [
                "Fast and reliable retail or counter sales in Odoo POS",
                "Offline selling support with sync when back online",
                "Instant integration with accounting and inventory",
                "Customer loyalty, discounts and promotions in one place",
                "Support for multiple stores, devices and cashiers",
                "Detailed sales reports and performance dashboards"
            ]
        } else if (slug.includes('Data-Migration') || slug.includes('Integration-API')) {
            return [
                "Data migrated safely with no critical loss",
                "Historical records and audit trails kept in Odoo",
                "Minimal disruption during system switchover",
                "Clean, validated data ready for reporting",
                "Better performance after consolidation and cleanup",
                "Stable integrations with external tools and platforms"
            ]
        } else if (slug.includes('Cloud') || slug.includes('Server')) {
            return [
                "High-availability hosting for Uniflame Odoo setups",
                "Secure infrastructure with SSL, backups and updates",
                "Scalable resources that grow with your workloads",
                "24×7 monitoring and proactive incident handling",
                "Fast response times and optimized performance",
                "Automated maintenance of servers and services"
            ]
        } else if (slug.includes('Training')) {
            return [
                "Confident, capable Odoo users in each department",
                "Lower daily dependency on external consultants",
                "Faster adoption of new modules and features",
                "Clear best practices for running operations in Odoo",
                "Reusable training material and reference guides",
                "Ongoing knowledge transfer from Uniflame experts"
            ]
        } else {
            return [
                "Streamlined operations with fewer manual tasks",
                "Real-time data flow between ERP and channels",
                "Higher efficiency and better team productivity",
                "More accurate reporting for smarter decisions",
                "A solution that scales as Uniflame clients grow",
                "Dedicated expert support and continuous improvement"
            ]
        }
    }

    const implementationProcess = getImplementationProcess()
    const serviceOutcomes = getServiceOutcomes()

    return (
        <Fragment>
            <div className="sco_agency">
                <Header />
                <main className="page_content service-single-page">
                    <section className="page-title  pt-200 pos-rel bg_img" style={{ backgroundImage: `url(${Bg})` }}>
                        <div className="container">
                            <div className="page-title-wrap sd-title-wrap">
                                <div className="row mt-none-30 align-items-end">
                                    <div className="col-lg-9 mt-30">
                                        <div className="page-title-box">
                                            <span className="sub-title"><img src={icon} alt="" /> {ServiceDetails.title}</span>
                                            <h2 className="title">
                                                {ServiceDetails.description || 'Discover Uniflame’s Odoo, e-commerce and app solutions.'}
                                            </h2>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 mt-25">
                                        <div className="sd-right-img pos-rel">
                                            <img src={srImg2} alt="" />
                                            <div className="sd-arrow-shape">
                                                <img className="xbzoominzoomup" src={srImg} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div className="video pt-70 pb-65">
                        <div className="container">
                            <div className="xb-video sd-video pos-rel">
                                <img src={vImg} alt="" />
                                <button className="popup-video btn-video" onClick={() => setOpen(true)}><img src={vImg2} alt="" /></button>
                            </div>
                        </div>
                    </div>
                    <div className="sd-ser-content_wrap pb-110">
                        <div className="container">
                            <div className="sd-ser-content">
                                <h2 className="sd-title">{ServiceDetails.title}</h2>
                                <p className="sd-content">
                                    {ServiceDetails.description}
                                </p>
                                <br />
                                {ServiceDetails.thumb1 && ServiceDetails.thumb2 && (
                                    <div className="sd-tags">
                                        <span className="badge bg-primary me-2">{ServiceDetails.thumb1}</span>
                                        <span className="badge bg-secondary">{ServiceDetails.thumb2}</span>
                                    </div>
                                )}
                                {ServiceDetails.features && ServiceDetails.features.length > 0 && (
                                    <div className="mt-4">
                                        <h4>Key features:</h4>
                                        <ul className="sd-ser-list list-unstyled">
                                            {ServiceDetails.features.map((feature, index) => (
                                                <li key={index}><img src={sicon} alt="" />{feature}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="sd-process_warp">
                        <div className="container">
                            <div className="sd-heading">
                                <h2 className="sd-title">{implementationProcess.title}</h2>
                                <p className="sd-content">{implementationProcess.description}</p>
                            </div>
                            <div className="sd-process_inner ul_li">
                                {implementationProcess.steps.map((step, index) => (
                                    <div className="sd-process-item" key={index}>
                                        <div className="xb-item--icon">
                                            <img src={[sImg1, sImg2, sImg3, sImg4][index]} alt="" />
                                        </div>
                                        <h3 className="xb-item--title">{step.title}</h3>
                                        <p className="xb-item--contact">{step.description}</p>
                                        <span className="xb-item--number">{step.number}</span>
                                    </div>
                                ))}
                                <div className="sd-shape"><img src={shape} alt="" /></div>
                            </div>
                        </div>
                    </div>
                    <div className="sd-service_wrap pt-115 pb-130">
                        <div className="container">
                            <div className="sd-ser-outcome">
                                <div className="sd-heading">
                                    <h2 className="sd-title">Service outcomes for {ServiceDetails.title}</h2>
                                    <p className="sd-content">Benefits and results you can expect from implementing this Uniflame solution:</p>
                                </div>
                                <div className="sd-list-item ul_li">
                                    <ul className="sd-ser-list list-unstyled">
                                        {serviceOutcomes.slice(0, 3).map((outcome, index) => (
                                            <li key={index}><img src={sicon} alt="" />{outcome}</li>
                                        ))}
                                    </ul>
                                    <ul className="sd-ser-list list-unstyled">
                                        {serviceOutcomes.slice(3, 6).map((outcome, index) => (
                                            <li key={index}><img src={sicon} alt="" />{outcome}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <CtaSection />
            </div>
            <Footer />
            <Scrollbar />
            <ModalVideo
                channel='youtube'
                autoplay
                isOpen={isOpen}
                videoId="nbso3NVz3p8"
                onClose={() => setOpen(false)}
            />
        </Fragment>
    )
};
export default ServiceSinglePage;
